import React from 'react'

import { Grid, RadioContainer, RadioWrapper, TitleBox } from '../auditorium.style'

interface MiddleColumnSelectorProps {
    columns: number
    defaultMiddleColumn: number | undefined
    setDefaultMiddleColumn: (value: number) => void
    onMiddleColumnChange: (value: number) => void
    disabled?: boolean
    name: string
}

const MiddleColumnSelector: React.FC<MiddleColumnSelectorProps> = ({
    columns,
    defaultMiddleColumn,
    setDefaultMiddleColumn,
    onMiddleColumnChange,
    name,
}) => {
    return (
        <RadioContainer>
            <TitleBox>Középvonal</TitleBox>
            <Grid rows={1} columns={columns - 1}>
                {Array.from({ length: columns - 1 }).map((_, columnIndex) => (
                    <RadioWrapper key={columnIndex}>
                        <input
                            type="radio"
                            name={name}
                            value={columnIndex + 1}
                            checked={defaultMiddleColumn === columnIndex + 1}
                            onChange={() => {
                                setDefaultMiddleColumn(columnIndex + 1)
                                onMiddleColumnChange(columnIndex + 1)
                            }}
                        />
                    </RadioWrapper>
                ))}
            </Grid>
            <TitleBox>Nézőtér</TitleBox>
        </RadioContainer>
    )
}

export default MiddleColumnSelector
